export default __webpack_public_path__ + "images/bg-shade.svg";